// extracted by mini-css-extract-plugin
export default {"noCoversations":"HomeMessages_noCoversations__wgH56","notification":"HomeMessages_notification__c6bhD"};